import { render, staticRenderFns } from "./topDesc.vue?vue&type=template&id=0968c9e6&scoped=true"
import script from "./topDesc.vue?vue&type=script&lang=js"
export * from "./topDesc.vue?vue&type=script&lang=js"
import style0 from "./topDesc.vue?vue&type=style&index=0&id=0968c9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968c9e6",
  null
  
)

export default component.exports